<template>
  <v-card flat class="mt-4 pa-0">
    <v-card-title class="pl-0">
      <h5>{{ title }}</h5>
    </v-card-title>
    <v-card-subtitle class="pl-0 mt-n8">
       {{ subtitle }}
    </v-card-subtitle>
    <v-card-text class="pl-0">
      <slot></slot>
    </v-card-text>
  </v-card>      
</template>
    
<script>
//- Rendering and formating helper
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    }
  }
}
</script>

<style>

</style>